"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSessionStorageValue = void 0;
var useStorageValue_1 = require("../useStorageValue/useStorageValue");
var const_1 = require("../util/const");
/**
 * Manages a single sessionStorage key.
 *
 * @param key Storage key to manage
 * @param defaultValue Default value to yield in case the key is not in storage
 * @param options
 */
function useSessionStorageValue(key, defaultValue, options) {
    if (defaultValue === void 0) { defaultValue = null; }
    if (options === void 0) { options = {}; }
    return (0, useStorageValue_1.useStorageValue)(const_1.isBrowser ? sessionStorage : {}, key, defaultValue, options);
}
exports.useSessionStorageValue = useSessionStorageValue;
